"use client";

import type { TextareaHTMLAttributes } from "react";
import { cn } from "./cn";
import { Field } from "./Field";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  helper?: string;
  error?: string;
}

export function Textarea({
  label,
  helper,
  error,
  required,
  id,
  className,
  ...rest
}: TextareaProps) {
  return (
    <Field label={label} helper={helper} error={error} required={required} htmlFor={id}>
      {({ fieldId, describedBy }) => (
        <textarea
          id={fieldId}
          className={cn("field-input", className)}
          required={required}
          aria-invalid={Boolean(error) || undefined}
          aria-describedby={describedBy}
          {...rest}
        />
      )}
    </Field>
  );
}
